import React, { useState } from "react";
import PropTypes              from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import Card        from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia   from "@mui/material/CardMedia";
import { CardActionArea } from "@mui/material";
import "./Cards.css";

export default function Cards({
  location,
  linkState,
  img,
  alt,
  subtitle,
  title,
  text,
  color = "#ffffff",
}) {
  const [shadow, setShadow] = useState("0 2px 8px rgba(0,0,0,0.10)");

  return (
    <Card
      sx={{
        minWidth: { xs: 330, sm: 500 },
        maxWidth: "100%",
        display: "flex",
        flex: 1,
        boxShadow: shadow,
        height: "fit-content",
        color,
      }}
      onMouseEnter={() => setShadow("0 10px 22px rgba(0,0,0,0.20)")}
      onMouseLeave={() => setShadow("0 2px 8px rgba(0,0,0,0.10)")}
    >
      <CardActionArea component={RouterLink} to={location} state={linkState}>
        <CardMedia component="img" height="450" image={img} alt={alt} />
        <CardContent>
          <p className="CardSubtitle">{subtitle}</p>
          <p className="CardTitle">{title}</p>
          <p className="CardText">{text}</p>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

/* ---------- prop-types ---------- */
Cards.propTypes = {
  location:  PropTypes.string.isRequired,
  linkState: PropTypes.object,              // { openIndex: number } or undefined
  img:       PropTypes.string.isRequired,
  alt:       PropTypes.string,
  subtitle:  PropTypes.string,
  title:     PropTypes.string.isRequired,
  text:      PropTypes.string,
  color:     PropTypes.string,
};
